<template>
    <div id="features" class="mb-6">
        <div class="bg-grey-lightest">
            <div class="container mx-auto px-6 pt-32">
                <h1 class="text-center text-black font-semibold text-2xl">
                    广州康莱医药有限公司概况
                </h1>
                <div class="flex md:flex-no-wrap xs:flex-wrap items-center justify-between mt-24">
                    <div class="px-6 py-6 m-2 text-center" style="min-width: 230px;">
                        <img src="./../assets/clsj.png" alt="mountain image" class="h-16 w-16 mb-4">
                        <h3 class="mb-4">成立时间</h3>
                        <p class="text-black font-base text-sm opacity-30">
                            2017年7月
                        </p>
                    </div>
                    <div class="px-6 py-6 m-2 text-center">
                        <img src="./../assets/clbj.png" alt="picnic image" class="h-16 mb-4">
                        <h3 class="mb-4">成立背景</h3>
                        <p class="text-black font-base text-sm opacity-30">
                            推动医疗行业持续健康发展，为构建人类命运共同体贡献力量。
                        </p>
                    </div>
                    <div class="px-6 py-6 m-2 text-center" style="min-width: 230px;">
                        <img src="./../assets/hydw.png" alt="tent image" class="h-16 mb-4">
                        <h3 class="mb-4">行业定位</h3>
                        <p class="text-black font-base text-sm opacity-30">
                            专业从事药品零售的零售企业
                        </p>
                    </div>
                </div>
                <div class="flex md:flex-no-wrap xs:flex-wrap items-center justify-center lg:mt-24">
                    <div class="flex-1">
                        <div class="px-12 py-12 m-4 text-center">
                            <img src="./../assets/hxll.png" alt="compass image" class="h-16 mb-4">
                            <h3 class="mb-4">核心理念</h3>
                            <p class="text-black font-thin text-xs opacity-30" style="font-size: 18px;">
                                “真诚服务，健康相伴”
                            </p>
                        </div>
                        <div class="px-12 py-12 m-4 text-center">
                            <img src="./../assets/hxqz.png" alt="canteen image" class="h-16 mb-4">
                            <h3 class="mb-4">核心旗帜</h3>
                            <p class="text-black font-thin text-xs opacity-30" style="font-size: 18px;">
                                “诚信、平价、友善”
                            </p>
                        </div>
                    </div>
                    <!-- <div class="xs:hidden md:flex-2 lg:flex-2">
                        <img src="./../assets/ll.png" width="300" height="300" alt="iphone image" class="h-iphone">
                    </div> -->
                    <div class="flex-1">
                        <div class="px-12 py-12 m-4 text-center">
                            <img src="./../assets/hxjzg.png" alt="forest image" class="h-16 mb-4">
                            <h3 class="mb-4">价值观</h3>
                            <p class="text-black font-thin text-xs opacity-30" style="font-size: 18px;">
                                “执着、进取、互助、贡献”
                            </p>
                        </div>
                        <div class="px-12 py-12 m-4 text-center">
                            <img src="./../assets/zlys.png" alt="pines image" class="h-16 mb-4">
                            <h3 class="mb-4">质量意识</h3>
                            <p class="text-black font-thin text-xs opacity-30" style="font-size: 18px;">
                                树立质量第一，产品溯源
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <svg id="curveDownColor" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
            <path style="fill: #f8fafc;" d="M0 0 C 50 100 80 100 100 0 Z" />
        </svg>
    </div>
</template>

<script>
    export default {
        data() {
            return {
    
            }
        }
    }
</script>
